import React, { Component } from 'react';
import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';

import texture1 from './img/text.png';
import texture2 from './img/text2.png';
import texture3 from './img/text3.png';
import texture4 from './img/text4.png';
import texture5 from './img/text5.png';

class Scene extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.renderer = null;
    this.scene = null;
    this.camera = null;

    this.group = null;

    this.stop = false;

    this.mouseX = window.innerWidth / 2
    this.mouseY = window.innerHeight / 2;

    // whatever object you'd want to control globally
    this.mobiusSmall = null;
    this.mobiusLarge = null;
    this.lock = null;
    this.paper = null;

    this.TIMER = 3000;
    this.SPACING = -10;
    this.ROTATION = 0.04;//.1;
    this.interval = null;
    this.currentTexture = 0;

    this.currentZ = this.currentR = 0;


    this._animate = this._animate.bind(this);
    this._addObjects = this._addObjects.bind(this);
    this._onDocumentMouseMove = this._onDocumentMouseMove.bind(this);
    this._onWindowResize = this._onWindowResize.bind(this);
    this._push = this._push.bind(this);
  }

  componentDidMount() {
    this._init();
  }

  componentWillUnmount() {
    this.stop = true;
    clearInterval(this.interval);
  }

  render() {
    return (
      <div ref="renderer" id="renderer"></div>
    );
  }

  _init() {
    this.scene = new THREE.Scene();

    this.camera = new THREE.PerspectiveCamera( 50, window.innerWidth / window.innerHeight, 1, 10000 );
    this.camera.position.z = 200;
    this.scene.add( this.camera );

    this.group = new THREE.Group();
    this.scene.add(this.group);

    this.renderer = new THREE.WebGLRenderer( { antialias: true, alpha: true } );
    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( window.innerWidth, window.innerHeight );
    this.refs.renderer.appendChild(this.renderer.domElement);

    this._addLights();
    this._addObjects();
    this._animate();

    document.addEventListener( 'mousemove', this._onDocumentMouseMove, false );
		window.addEventListener( 'resize', this._onWindowResize, false );
  }

  _geo(u, t) {/*
    u = u - 0.5;
		var v = 2 * Math.PI * t;

		var x, y, z;

		var a = 2;
		x = Math.cos(v) * (a + u * Math.cos(v/2));
		y = Math.sin(v) * (a + u * Math.cos(v/2));
		z = u * Math.sin(v/2);
		return new THREE.Vector3(x, y, z);
*/

    u *= Math.PI;
		t *= 2 * Math.PI;

		u = u * 2;
		var phi = u / 2;
		var major = 2.25, a = 0.125, b = 0.65;
		var x, y, z;
		x = a * Math.cos(t) * Math.cos(phi) - b * Math.sin(t) * Math.sin(phi);
		z = a * Math.cos(t) * Math.sin(phi) + b * Math.sin(t) * Math.cos(phi);
		y = (major + x) * Math.sin(u);
		x = (major + x) * Math.cos(u);
		return new THREE.Vector3(x, y, z);

  }

  _addLights() {
    //var ambientLight = new THREE.AmbientLight(0xEEEEEE, 1);
    //this.scene.add(ambientLight);

    var directLightLeft = new THREE.PointLight(0xdecba4, 1);
    directLightLeft.position.set(300,0,40);
    this.scene.add(directLightLeft);

    var directLightLeft2 = new THREE.PointLight(0x3e5151, 1);
    directLightLeft2.position.set(-300,0,40);
    this.scene.add(directLightLeft2);
  }

  _addObjects() {
    var m1 = new THREE.MeshPhongMaterial({
      color: 0xFFFFFF,
      map: new THREE.TextureLoader().load( texture1 )
    });

    var m2 = new THREE.MeshPhongMaterial({
      color: 0xFFFFFF,
      map: new THREE.TextureLoader().load( texture2 )
    });

    var m3 = new THREE.MeshPhongMaterial({
      color: 0xFFFFFF,
      map: new THREE.TextureLoader().load( texture3 )
    });

    var m4 = new THREE.MeshPhongMaterial({
      color: 0xFFFFFF,
      map: new THREE.TextureLoader().load( texture4 )
    });

    var m5 = new THREE.MeshPhongMaterial({
      color: 0xFFFFFF,
      map: new THREE.TextureLoader().load( texture5 )
    });




    var mWhite = new THREE.MeshPhongMaterial({
      color: 0xFFFFFF
    });

    var mat1 = [mWhite, mWhite, mWhite, mWhite, m1, mWhite];
    var mat2 = [mWhite, mWhite, mWhite, mWhite, m2, mWhite];
    var mat3 = [mWhite, mWhite, mWhite, mWhite, m3, mWhite];
    var mat4 = [mWhite, mWhite, mWhite, mWhite, m4, mWhite];
    var mat5 = [mWhite, mWhite, mWhite, mWhite, m5, mWhite];

    this.paper = [
      new THREE.Mesh(new THREE.BoxBufferGeometry( 80, 110, 3), mat1),
      new THREE.Mesh(new THREE.BoxBufferGeometry( 80, 110, 3), mat2),
      new THREE.Mesh(new THREE.BoxBufferGeometry( 80, 110, 3), mat3),
      new THREE.Mesh(new THREE.BoxBufferGeometry( 80, 110, 3), mat4),
      new THREE.Mesh(new THREE.BoxBufferGeometry( 80, 110, 3), mat5),
    ];


    //this.group.rotation.y = Math.PI * -0.25;
    this.camera.position.x = 150;
    this.camera.position.z = 100;
    var c = 0;
  //  var n = 0;
    var r = 0;

    this.currentTexture = 0;
    for(let x = 0 ; x < 100 ; x++) {
      let paper = this.paper[this.currentTexture].clone();
      paper.position.z = c;
      paper.rotation.z = r;
      c+= this.SPACING;
      //n+= 1;
      r += this.ROTATION;
      this.group.add(paper);

      this.currentTexture++;
      if(this.currentTexture > this.paper.length-1) {
        this.currentTexture = 0;
      }
    }

    this.group.position.z = -1000;
    new TWEEN.Tween(this.group.position)
        .to({ z: 0}, 2000)
        .easing(TWEEN.Easing.Exponential.Out)
        .start()
        .onComplete(()=>{
          this._start();
        });

    //this._start();
  }

  _start() {
    var self = this;
    this.currentTexture++;
    this.interval = setInterval(()=>{

      if(self.props.pause) {
        return;
      }
      self._push();
    }, this.TIMER);

  }
  _push() {

    var z = this.group.position.z + this.SPACING;
    var r = this.group.rotation.z + this.ROTATION;//0.1;
    new TWEEN.Tween(this.group.rotation)
        .to({ z: r}, 1000)
        .easing(TWEEN.Easing.Exponential.Out)
        .start();

    let paper = this.paper[this.currentTexture].clone();
    this.currentTexture++;
    if(this.currentTexture > this.paper.length-1) {
      this.currentTexture = 0;
    }

    this.currentZ += -this.SPACING;
    this.currentR += -this.ROTATION;

    paper.position.z = this.currentZ;
    paper.position.y = -800;
    paper.rotation.z = this.currentR;

    this.group.add(paper);
    //paper.position.x = n;
    //

    new TWEEN.Tween(paper.position)
        .to({ y: 0}, 1000)
        .easing(TWEEN.Easing.Exponential.Out)
        .start();

    new TWEEN.Tween(this.group.position)
        .to({ x: 0, y: 0, z: z}, 1000)
        .easing(TWEEN.Easing.Exponential.Out)
        .start(); // Start the tween immediately.
  }

  _addObjects2() {
    /*var loader = new THREE.ObjectLoader();
    loader.load(process.env.PUBLIC_URL + 'model.json', (geometry) => {
      //console.log("airplane loaded");
      var g = geometry.children[0].geometry;
      g.center();

      this.lock = new THREE.Mesh(
        g,
        new THREE.MeshPhongMaterial({
          color: 0xEEEEEE,
          //shininess: 1000
          //map: tex
        })
      );

      this.lock.scale.set(0.003,0.003,0.003);
      this.lock.rotation.z = Math.PI;

      this.scene.add(this.lock);
    });


    var geometry = new THREE.ParametricGeometry( this._geo, 100, 40);

    var tex = new THREE.TextureLoader().load( texture );
    tex.repeat.x = 100 / 800;
    tex.repeat.y = 100 / 2000;
    tex.offset.x = ( 300 / 100 ) * tex.repeat.x;
    tex.offset.y = ( 400 / 100 ) * tex.repeat.y;

    this.mobiusSmall = new THREE.Mesh(
      geometry,
      new THREE.MeshPhongMaterial({
        color: 0x999999,
        //map: tex
      })
    );

    this.mobiusSmall.rotation.y = Math.PI * -0.2;
    this.mobiusSmall.rotation.x = Math.PI * -0.35;

    this.mobiusSmall.scale.multiplyScalar( 16 );

    this.mobiusLarge = new THREE.Mesh(
      geometry,
      new THREE.MeshBasicMaterial({
        color: 0x999999,
        wireframe: true
      })
    );

    this.mobiusLarge.scale.multiplyScalar( 30 );
    this.mobiusLarge.rotation.y = Math.PI * 0.3;
    this.group.add(this.mobiusSmall);
    //this.group.add(this.mobiusLarge);

    var torusKnot = new THREE.Mesh(
      new THREE.TorusKnotBufferGeometry( 100, 0.5, 300, 6 ),
      new THREE.MeshPhongMaterial( { color: 0xEEEEEE } )
    );
    this.group.add( torusKnot );

    var blah = new THREE.Mesh(
        new THREE.DodecahedronGeometry(5, 0),
        new THREE.MeshPhongMaterial({
          color: 0xFF0000
        })
      );
    //this.group.add(blah);
    */
  }

  _animate() {
    if(this.props.pause || this.stop) {
      return;
    }
    //this.mobiusSmall.rotation.x += 0.001;
    //this.group.rotation.y += 0.001;
    //if(this.lock) this.lock.rotation.y -= 0.005;
    //this.mobiusLarge.rotation.z -= 0.0025;
  //  this.mobiusSmall.rotation.y += 0.0008;

    TWEEN.update();
    this.camera.lookAt(this.scene.position);

    //this.group.rotation.x += ( this.mouseY - this.group.rotation.x ) * 0.00008;
		//this.group.rotation.y += ( - this.mouseX - this.group.rotation.y ) * 0.00008;

    //this.camera.position.x += ( this.mouseX - this.camera.position.x ) * 0.05;
    //this.camera.position.y += ( - this.mouseY - this.camera.position.y ) * 0.05;

    this.renderer.render(this.scene, this.camera);
    requestAnimationFrame(this._animate);
  }

  _onDocumentMouseMove(e) {
    this.mouseX = ( e.clientX - (window.innerWidth / 2) );
		this.mouseY = ( e.clientY - (window.innerHeight / 4) );

  }

  _onWindowResize() {
    this.camera.aspect = window.innerWidth / window.innerHeight;
		this.camera.updateProjectionMatrix();
		this.renderer.setSize( window.innerWidth, window.innerHeight );
  }
}

export default Scene;



// WEBPACK FOOTER //
// ./src/Scene.js